import {
  ScopeOfPracticeEnum,
  ShiftTypeEnum,
  TimeString,
  ShiftStatusEnum
} from '@umss/shared/utils';

export interface CreateShiftNeedDto {
  facilityId: string; // Guid in backend
  facilitySubtypeId?: number | null;
  scopeOfPractice: ScopeOfPracticeEnum;
  description?: string | null; // Max length: 1000
  shiftType: ShiftTypeEnum;
  shiftDate: string; // DateOnly in backend - ISO date format: YYYY-MM-DD
  startTime: TimeString; // TimeOnly in backend - Time format: HH:mm or HH:mm:ss
  endTime: TimeString; // TimeOnly in backend - Time format: HH:mm or HH:mm:ss
  numberOfPositions: number; // Default: 1, Range: 1-10
  bonus?: number | null; // Optional facility bonus (>= 0). Backend resolves base rate from FacilityBillableRate.
  hourlyRate?: number | null; // Optional facility rate override (0.01-1000.00, no bonus). Omit to use the FacilityBillableRate.
  specialInstructions?: string | null; // Max length: 1000
  expiresAt?: string | null; // DateTime in backend - ISO datetime format
  isUrgent: boolean; // Default: false
  isRecurring: boolean; // Default: false
  recurringPatternId?: number | null;
  allowEarlyClockIn?: boolean; // Default: false
  allowLateClockOut?: boolean; // Default: false
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface UpdateShiftNeedDto extends Omit<
  CreateShiftNeedDto,
  'facilityId'
> {}

export interface ShiftNeedRequestsSearchDto {
  status?: ShiftStatusEnum;
  initiated?: 'contractor' | 'facility';
  pageNumber?: number;
  pageSize?: number;
}
